/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_ScheduleInputs */

const en_jobs_schedule = /** @type {(inputs: Jobs_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const he_jobs_schedule = /** @type {(inputs: Jobs_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תזמון`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Jobs_ScheduleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_schedule = /** @type {((inputs?: Jobs_ScheduleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_ScheduleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_schedule(inputs)
	return he_jobs_schedule(inputs)
});